import AttendanceCardView from "Pages/MySchedule/Attendance/AttendanceCardView";
import React from "react";
import "./index.css";

function AttendanceCardgroup(props: any) {
  const {
    screen,
    students,
    handleAttendance,
    handleAbsent,
    presentStudentList,
    onlineStudentList,
    handleStudentStatus,
    handleDeleteStudentStatus,
  } = props;
  return (
    <div className="student-group">
      <div className="w-100 mt-2">
        {students.map((user: any, index: any) => (
          <div
            key={user.psid}
            className={`student-CardView ${
              index == students.length - 1 ? "" : ""
            }`}
          >
            <AttendanceCardView
              key={user.psid}
              cardData={user}
              screen={screen}
              handleAttendance={handleAttendance}
              handleAbsent={handleAbsent}
              presentStudentList={presentStudentList}
              onlineStudentList={onlineStudentList}
              handleStudentStatus={handleStudentStatus}
              handleDeleteStudentStatus={handleDeleteStudentStatus}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default AttendanceCardgroup;
